export default (theme) => ({
  videoFeedWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'stretch',
    alignContent: 'stretch',
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#3B3B3B',
  },
  videoRoomParticipant: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  participantVideoItem: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  fullLocalParticipantVideoItem: {
    position: 'relative',
    height: '100%',
    width: '100%',
    '& video': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
  localParticipantVideoItem: {
    height: 130,
    width: 240,
    borderRadius: 20,
    position: 'absolute',
    overflow: 'hidden',
    top: 20,
    right: 20,
    zIndex: 100,
    [theme.breakpoints.down('sm')]: {
      width: 100,
      borderRadius: 10,
    },
  },
  gridParticipantVideoItem: {
    display: 'block',
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: 'auto',
    alignSelf: 'auto',
    order: 0,
    position: 'relative',
    minWidth: '50%',
    width: '50%',
    height: 'auto',
    overflow: 'hidden',
  },
  smallGridParticipantVideoItem: {
    minWidth: 'calc(100% / 3)',
    width: 'calc(100% / 3)',
  },
  shareParticipantVideoItem: {
    width: 'calc(100% - 120px)',
    height: '100%',
    position: 'relative',
  },
  rightFeed: {
    width: 120,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  rightFeedParticipantVideoItem: {
    display: 'block',
    position: 'relative',
    width: '100%',
    height: 90,
  },
  smallRightFeedParticipantVideoItem: {
    height: 'calc(100% / 12)',
  },
  session: {
    width: '100%',
    height: '100%',
  },
});
